import * as React from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import { ReloadApp } from "source/app/presentation/App";
import { ShareState } from "../../../../services/UI/State/ShareState";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";

export function ToggleDeviceModeState() {
    const [isDesktopModeAllowed, setIsDesktopModeAllowed] =
        React.useState(false);

    ShareState(
        ESharedFunction.ToggleDeviceMode_isDesktopModeAllowed,
        isDesktopModeAllowed,
        setIsDesktopModeAllowed
    );

    return null;
}

export function SwitchDeviceMode() {
    localStorage.setItem("isMobile", String(!IsMobileDevice()));
    ReloadApp();
}
